export const SUCCESS_ADD_CONTENT = 'Thêm  thông tin bài khảo sát thành công';
export const SUCCESS_EDIT_CONTENT = 'Cập nhật thông tin bài khảo sát thành công';

export const SUCCESS_ADD_IMAGE = 'Thêm ảnh thành công';
export const SUCCESS_LOGIN = 'Đăng nhập thành công';
export const ERROR_LOGIN = 'Đăng nhập thất bại';
export const SUCCESS_UPLOAD = 'Upload thành công';
export const SUCCESS_DELETE = 'Xóa thành công';
export const ERROR_DELETE = 'Xóa thất bại';

export const ERROR_UPLOAD_FILE = (value: number) => `Vui lòng chọn ảnh dưới ${value} MB`;
export const ERROR_UPLOAD_MAX = (value: number) => `Vui lòng chọn file dưới ${value} MB`;
export const ERROR_UPLOAD_MAX_FILE = 'Tối đa chỉ upload được 10 file';
export const ERROR_SERVER = 'Lỗi server';
export const ERROR_NOT_FOUND_API = 'Không có dữ liệu';
export const ERROR_EXPIRED_TOKEN = 'Đã hết thời hạn truy cập. Vui lòng Đăng nhập lại';
export const ERROR_EXPIRED_ACCOUNT = 'Tài khoản chưa được kích hoạt hoặc bị khóa!';
export const ERROR_EMPTY_FIELD = 'Không bỏ trống trường này';
export const ERROR_DELETE_EXIST_QUESTION = 'Không thể xóa câu hỏi đang dùng trong bài khảo sát';

export const VALIDATE_BEGIN_DATE = 'Vui lòng chọn hoặc nhập ngày bắt đầu';
export const VALIDATE_END_DATE = 'Vui lòng chọn hoặc nhập ngày kết thúc';
export const VALIDATE_BEGIN_DATE_LIMITATION = 'Vui lòng nhập ngày bắt đầu nhỏ hơn ngày kết thúc';
export const VALIDATE_END_DATE_LIMITATION = 'Vui lòng nhập ngày kết thúc lớn hơn ngày bắt đầu';
export const VALIDATE_INVALID_DATE = 'Vui lòng nhập ngày tháng năm hợp lệ';
export const VALIDATE_TEXT_LIMITATION = (value: number) => `Không nhập quá ${value} ký tự`;

export const VALIDATE_QUESTION_CONTENT = 'Vui lòng nhập nội dung câu hỏi';
export const VALIDATE_ANSWER_CONTENT = 'Vui lòng nhập nội dung câu trả lời';
export const VALIDATE_QUESTION = 'Vui lòng nhập đủ nội dung cần thiết';
export const VALIDATE_DELETE_ROW = (value: number) => `Cần ít nhất ${value} trường`;

export const SURVEY_ERROR_FULFILL_REQUIREMENTS =
  'Vui lòng hoàn thành tab "Thông tin chung" và ấn "Lưu"';
export const SURVEY_ERROR_ADD_QUESTION_EXISTED = 'Câu hỏi này đã được nhập';

export const SUCCESS_CHANGE_STATUS_DEFAULT = 'Thay đổi trạng thái bài khảo sát thành công';
export const SUCCESS_LOCK_SURVEY_STATUS = 'Khoá bài khảo sát thành công';
export const SUCCESS_PUBLISH_SURVEY_STATUS = 'Phát hành bài khảo sát thành công';
export const SUCCESS_DRAFT_SURVEY_STATUS = 'Soạn thảo bài khảo sát thành công';
export const SUCCESS_CHANGE_SURVEY_STATUS_FUNC = (status: string) =>
  `Đổi trạng thái ${status} thành công`;

export const SUCCESS_SUBMIT_SURVEY = 'Gửi bài khảo sát thành công';
export const ERROR_EMPTY_ANSWER_SURVEY = 'Vui lòng trả lời câu hỏi này';
export const ERROR_INVALID_ANSWER_SUBMIT =
  'Chưa trả lời câu hỏi bắt buộc hoặc câu trả lời không hợp lệ';
export const ERROR_SUBMIT_SURVEY = 'Có lỗi xảy ra không thể gửi bài khảo sát';

export const SUCCESS_COPY_SURVEY = 'Sao chép bài khảo sát thành công';
export const ERROR_COPY_SURVEY = 'Sao chép bài khảo sát thất bại';
export const ERROR_COPY_LINK = 'Sao chép thất bại';

export const SUCCESS_EXPORT_EXCEL = 'Xuất excel thành công';
export const ERROR_EXPORT_EXCEL_NO_DATA = 'Không có dữ liệu để xuất excel';

export const ERROR_CHANGE_TAB_3_4 =
  'Vui lòng hoàn thành tab "Nội dung" và "Danh sách thành viên" và bấm Lưu';
export const ERROR_CHANGE_TAB_3_PRIVATE = 'Vui lòng hoàn thành tab "Nội dung" và bấm Lưu';

export const ERROR_NO_PEOPLE_DO_SURVEY = 'Chưa có người làm khảo sát nào';

export const ERROR_SEND_SMS = 'Gửi thông báo thất bại';
export const SUCCESS_SEND_SMS = 'Đang tiến hành gửi thông báo. Vui lòng chờ trong ít phút';

export const ERROR_GET_CLIENT_INFO = 'Lấy thông tin trình duyệt thất bại';

export const ERROR_NO_FILE_SAVED = 'Chưa có file nào được lưu trữ';

export const WARNING_EDIT_SURVEY_IN_PUBLISHED_SURVEY =
  'Bài khảo sát này đã được phát hành. Nếu điều chỉnh có thể ảnh hưởng đến kết quả khảo sát. Bạn có muốn tiếp tục không?';

export const WARNING_EDIT_SURVEY_IN_FINISHED_SURVEY =
  'Bài khảo sát này đã kết thúc. Nếu điều chỉnh có thể ảnh hưởng đến kết quả khảo sát. Bạn có muốn tiếp tục không?';

export const ERROR_NO_ANSWER_QUESTION_TYPE10 =
  'Vui lòng hoàn thành câu hỏi người được đánh giá và bấm lưu';

export const ERROR_NO_PERMISSION_VIEW_SURVEY_RESULT =
  'Bạn không được phân quyền để xem nội dung này';
export const ERROR_BONUS_CODE =
  'Số lượng nhận thưởng an toàn phải nhỏ hơn hoặc bằng số lượng nhận thưởng tối đa';

export const ERROR_SAVE_EVALUATED_QUESTION = 'Không có người được đánh giá được chọn';

export const CONFIRM_DELETE_MODAL = 'Bạn có chắc muốn xóa?';

export const CONFIRM_PUBLISH_ANSWER =
  'Nếu chọn Có, người làm khảo sát sẽ thấy toàn bộ kết quả khảo sát của bài khảo sát này. Bạn có đồng ý công khai kết quả khảo sát không?';

export const ERROR_UPDATE_QUESTION_EXIST_IN_SURVEY =
  'Không thể chỉnh sửa câu hỏi đã nằm trong bài khảo sát';

export const ERROR_UPDATE_QUESTION_IN_SURVEY_PUBLISH =
  'Câu hỏi này và tất cả dữ liệu phản hồi được thu thập trước đó cho nó sẽ bị xóa vĩnh viễn. Bạn có muốn tiếp tục không?';

export const WARNING_UPDATE_QUESTION_IN_SURVEY =
  'Bài khảo sát đã phát hành, nếu sửa thì dữ liệu phản hồi được thu thập trước đó cho nó sẽ bị thay đổi. Bạn có muốn tiếp tục không';

export const CONFIRM_PUBLISH_SURVEY = 'Bạn có muốn chuyển trạng thái thành Phát hành hay không ?';
export const CONFIRM_DRAFTING_SURVEY =
  'Bạn có muốn quay trở lại trạng thái Đang soạn thảo hay không ?';

export const ERROR_UPLOAD_EXCEL_QUESTION = 'Có lỗi hệ thống, không thể upload excel vào lúc này';

export const ERROR_NOT_COMPLETED_EVALUATED_QUESTION =
  "Vui lòng hoàn thành câu hỏi 'Người được đánh giá' ở tab 'Nội dung và bấm lưu'";

export const WARNING_EXIT_EDIT_SURVEY = 'Bạn có muốn lưu các thông tin thay đổi không ?';

export const SUCCESS_EXIT_AND_SAVE_SURVEY = 'Cập nhật thông tin bài khảo sát thành công';

export const SUCCESS_ADD_QUESTION_CONTENT = 'Cập nhật thông tin thành công';
export const SUCCESS_EDIT_QUESTION_CONTENT = 'Cập nhật thông tin thành công';

export const NO_DATA_IN_TABLE = 'Không có dữ liệu';
export const NO_PERMISSION_VIEW_TABLE = 'Bạn không có quyền xem danh sách này';

export const EXCEED_MAX_LENGTH_INPUT_TEXT = (fieldInput = 'chữ', maxLength = 250) =>
  `Vui lòng nhập độ dài ${fieldInput} nhỏ hơn hoặc bằng ${maxLength} kí tự`;

export const NO_PEOPLE_NO_DO_SURVEY =
  'Danh sách chưa hoàn thành bài khảo sát đang không có dữ liệu';

export const ERROR_NOT_COMPLETED_SURVEY = 'Vui lòng hoàn thành thông tin bài khảo sát';

export const ERROR_NO_QUESTION_VALID_UPLOAD = 'Không có câu hỏi nào hợp lệ để upload';
export const ERROR_STAFF_VALID_UPLOAD = 'Không có nhân viên nào hợp lệ để upload';

export const ERROR_MOVE_TO_EVALUATED_QUESTION =
  'Không thể di chuyển tới câu hỏi "người được đánh giá"';

export const ERROR_NUMBER_ORDER_QUESTION = 'Vui lòng nhập số nguyên dương';

export const ERROR_NUMBER_EQUAL_ZERO_ORDER_QUESTION = 'Vui lòng nhập số lớn hơn 0';

export const ERROR_NO_VALUE_IN_ORDER_QUESTION = 'Vui lòng nhập thứ tự câu hỏi';

export const ERROR_EXCEED_NUMBER_ORDER_QUESTION = (maxNumber: string) =>
  `Vui lòng nhập số nhỏ hơn hoặc bằng ${maxNumber}`;
export const ERROR_CHECK_QUESTION_UPLOAD = 'Phát hiện file có sự thay đổi. Vui lòng chọn lại file';

export const SUCCESS_DELETE_QUESTION_IN_SURVEY = 'Xoá câu hỏi trong bài khảo sát thành công';
export const SUCCESS_DELETE_SECTION_IN_SURVEY = 'Xoá mục trong bài khảo sát thành công';

export const SUCCESS_MOVE_QUESTION_IN_SURVEY = (index: number) =>
  `Di chuyển câu hỏi tới vị trí thứ ${index} thành công`;

export const SUCCESS_MOVE_SECTION_IN_SURVEY = 'Di chuyển mục thành công';

export const ERROR_NOTIFY_WHEN_FIELD_INPUT_NOT_VALID =
  'Nhập thiếu/sai các trường thông tin bắt buộc';

export const ERROR_SELECT_FIELD_INPUT_NOT_VALID = (fieldName: string) =>
  `Vui lòng chọn ${fieldName} hợp lệ`;

export const ERROR_TEXT_FIELD_INPUT_NOT_VALID = (fieldName: string) =>
  `Vui lòng nhập ${fieldName} hợp lệ`;

export const ERROR_NO_CATEGORY_MATRIX_LIST_VALUE = (index: number) =>
  `Vui lòng nhập danh mục cho cột ${index}`;

export const SUCCESS_COPY_QUESTION_IN_SURVEY = 'Sao chép câu hỏi trong bài khảo sát thành công';
export const SUCCESS_COPY_QUESTION_IN_QUESTION_BANK = 'Sao chép câu hỏi thành công';

export const ERROR_FAILED_TO_COPY = 'Có lỗi xảy ra sao chép thất bại';

export const ERROR_FAILED_LOAD_AVAILABLE_QUESTION_IN_SURVEY =
  'Có lỗi xảy ra không thể tải câu hỏi có sẵn';

export const ERROR_FAILED_LOAD_DDL_ADD_QUESTION =
  'Có lỗi xảy ra không thể tải dữ liệu của dropdown';

export const ERROR_CHANGE_UI_TOO_FAST =
  'Bạn đang thao tác quá nhanh! Vui lòng chờ nửa giây rồi tiếp thục thao tác';

export const VALIDATE_STAFF_CONTENT = 'Vui lòng chọn nhân viên và bấm thêm';

export const MAX_LENGTH_DOCUMENT_QUESTION = 3000;

export const ERROR_EXCEED_MAX_LENGTH_DOCUMENT_QUESTION = `Vui lòng nhập câu trả lời dưới ${MAX_LENGTH_DOCUMENT_QUESTION} ký tự`;

export const NO_DATA_FOR_ADD_USER = 'Không có nhân viên nào để thêm';

export const SUCCESS_DOWNLOAD_TEMPLATE_EXCEL = 'Tải template thành công';

export const ERROR_VALID_DATE_SUBMIT_SURVEY = 'Vui lòng nhập ngày tháng năm hợp lệ';

export const ERROR_VALID_TIME_SUBMIT_SURVEY = 'Vui lòng nhập giờ phút giây hợp lệ';
export const ERROR_COMMON_UPLOAD_STAFF_NORMAL = 'Có lỗi xảy ra! Không thể upload file vào lúc này';

export const ERROR_LOAD_LIST_STAFF = 'Lỗi lấy dữ liệu danh sách nhân viên';

export const SUCCESS_ADD_STAFF_EVALUATED = 'Thêm người được đánh giá thành công';

export const ERROR_EXIST_STAFF_IN_TABLE = 'Mã nhân viên đã tồn tại trên danh sách';

export const ERROR_DUPLICATE_STAFF_IN_FILE = 'Mã nhân viên bị trùng lặp trong file tải lên';

export const ERROR_FORMAT_IMAGE = 'Vui lòng chọn ảnh có đuôi là jpg, jpeg, png, gif';

export const SUCCESS_COPY = 'Sao chép thành công';
export const ERROR_COPY = 'Sao chép thất bại';
export const ERROR = 'Có lỗi xảy ra';
export const ERROR_NOT_FORMAT_EXCEL = 'Không phải định dạng hợp lệ';
export const VALIDATE_NO_CONTENT_BEFORE_SAVE = 'Cần nhập nội dung trước khi lưu';
export const VALIDATE_DATA_EXITS = 'Dữ liệu không được trùng';

export const QUESTION_NOT_FOUND = 'Câu hỏi không tồn tại';
export const NO_PERMISSION_EDIT_QUESTION = 'Bạn không có quyền sửa câu hỏi này';
export const SURVEY_NOT_FOUND = 'Bài khảo sát không tồn tại';
export const CONFIRM_DELETE_SURVEY = 'Bạn có chắc chắn muốn xóa bài khảo sát không?';
export const SUCCESS_COPY_LINK_SURVEY = 'Đã sao chép link bài khảo sát.';
export const ERROR_COPY_LINK_SURVEY = 'Có lỗi xảy ra khi sao chép link bài khảo sát này.';
export const SUCCESS_UPLOAD_QUESTION = 'Cập nhật thông tin thành công';
export const CONFIRM_DELETE_QUESTION = 'Bạn có chắc muốn xoá câu hỏi không?';

export const ERROR_NO_PERMISSION_EXPORT_EXCEL = 'Bạn không có quyền xuất excel';
